import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=3ed60aac&scoped=true&"
import script from "./Batches.vue?vue&type=script&lang=ts&"
export * from "./Batches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed60aac",
  null
  
)

export default component.exports